document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('vs-modal');
    const closeBtn = document.getElementById('vs-close-btn');
    const backdrop = document.getElementById('vs-close-backdrop');
    const openModalBtn = document.getElementById('open-vs-modal');
    
    let modalContent = document.getElementById('vs-modal-content');
    if (!modalContent) {
        modalContent = modal?.querySelector('[id*="modal"]') || modal?.querySelector('[class*="modal"]');
    }

    const uploadArea = document.getElementById('vs-upload-area');
    const uploadPrompt = document.getElementById('vs-upload-prompt');
    const fileInput = document.getElementById('vs-file-input');
    const uploadTrigger = document.getElementById('vs-upload-trigger');
    
    const cropperContainer = document.getElementById('vs-cropper-container');
    const cropperImage = document.getElementById('vs-cropper-image');
    const cropActions = document.getElementById('vs-crop-actions');
    const searchBtn = document.getElementById('vs-search-btn');

    const loadingState = document.getElementById('vs-loading');
    const resultsContainer = document.getElementById('vs-results-container');
    
    const popularSection = document.getElementById('vs-popular-section');
    const popularProductsContainer = document.getElementById('vs-popular-products');

    let cropper = null;
    let currentFile = null;
    let popularProducts = [];
    let globalDragCounter = 0;
    let autoSearchTimeout = null;
    let cropCheckInterval = null;
    let isSearching = false;
    let hasInitialSearched = false;
    let lastSearchCropData = null;
    let resultsExpanded = false;

    // Cached image classification (gender/category) so crop-refine searches of the
    // SAME uploaded image skip the Gemini call on the server. Reset on every new upload.
    let cachedGender = null;
    let cachedCategory = null;
    let cachedCropData = null; // crop box used when we cached the classification above

    const CONFIG = {
        SHOPIFY_DOMAIN: 'uk.kalkifashion.com',
        STOREFRONT_TOKEN: 'adce4ee916b13aa6db2d71a2662a8f91',
        MAX_RETRIES: 3,
        RETRY_DELAY: 1500,
        AUTO_SEARCH_DELAY: 800,
        INITIAL_SEARCH_DELAY: 1000
    };

    // ============================================
    // BLOCKED PRODUCTS  (hidden from image-search results on THIS store)
    // Paste your 5 product IDs below. Numeric ('1234567890') or full gid
    // ('gid://shopify/Product/1234567890') both work.
    // ============================================
    const BLOCKED_PRODUCT_IDS = [
        '10068354335000',
        '9006376485144',
        '8967549321496',
        '9556210745624',
        '9885913219352',
    ];

    // Reduce any id to just its trailing number so numeric IDs and gids compare equal.
    function normalizeProductId(id) {
        if (id === null || id === undefined) return '';
        const s = String(id).trim();
        const m = s.match(/(\d+)\s*$/);
        return m ? m[1] : s;
    }
    const blockedIdSet = new Set(BLOCKED_PRODUCT_IDS.map(normalizeProductId).filter(Boolean));


    // ============================================
    // CREATE EXPAND/COLLAPSE BUTTON
    // ============================================
    const expandWrapper = document.getElementById('vs-expand-wrapper');
    const expandButton = document.getElementById('vs-expand-btn');
    
    if (expandButton) {
        expandButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleResultsExpand();
        });
    }


    // ============================================
    // TOGGLE FUNCTION
    // ============================================
    function toggleResultsExpand() {
        if (!modal) return;
        
        resultsExpanded = !resultsExpanded;
        
        if (resultsExpanded) {
            modal.classList.remove('vs-results-collapsed');
            modal.classList.add('vs-results-expanded');
            if (expandButton) {
                expandButton.innerHTML = '▲';
                expandButton.setAttribute('aria-label', 'Collapse results');
            }
            
            // Scroll to top on mobile
            if (window.innerWidth <= 768) {
                setTimeout(() => {
                    modal.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
            console.log('✅ Results expanded');
        } else {
            modal.classList.remove('vs-results-expanded');
            modal.classList.add('vs-results-collapsed');
            if (expandButton) {
                expandButton.innerHTML = '▼';
                expandButton.setAttribute('aria-label', 'Expand results');
            }
            console.log('✅ Results collapsed');
        }
    }

    // ============================================
    // IMAGEKIT URL CONVERTER
    // ============================================
    function convertToImageKitUrl(shopifyUrl) {
        if (!shopifyUrl) return null;
        
        if (shopifyUrl.includes('ik.imagekit.io')) {
            return shopifyUrl;
        }
        
        if (shopifyUrl.includes('cdn.shopify.com')) {
            const urlParts = shopifyUrl.split('?')[0];
            const filename = urlParts.split('/').pop();
            const params = shopifyUrl.includes('?') ? '?' + shopifyUrl.split('?')[1] : '';
            return `https://ik.imagekit.io/4sjmoqtje/kalki-uk/tr:w-370,c-at_max/cdn/shop/files/${filename}${params}`;
        }
        
        return shopifyUrl;
    }

    // DRAG-TO-SEARCH
    const dragOverlay = document.createElement('div');
    dragOverlay.id = 'vs-drag-overlay';
    Object.assign(dragOverlay.style, {
        position: 'fixed', top: '0', left: '0', right: '0', bottom: '0',
        backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'none', zIndex: '9999',
        justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(2px)',
        opacity: '0', transition: 'opacity 0.2s ease', flexDirection: 'column', gap: '20px'
    });

    const dragMessage = document.createElement('div');
    dragMessage.style.cssText = 'text-align: center; color: #fff; font-size: 32px; font-weight: 600; font-family: sans-serif; pointer-events: none;';
    dragMessage.innerHTML = `<div style="font-size: 64px; margin-bottom: 20px;">📸</div><div>Drop to Search by Image</div>`;
    dragOverlay.appendChild(dragMessage);
    document.body.appendChild(dragOverlay);

    let isDraggingFiles = false;

    document.addEventListener('dragenter', (e) => {
        const hasFiles = e.dataTransfer.types && e.dataTransfer.types.includes('Files');
        const hasImageUrl = e.dataTransfer.types && (e.dataTransfer.types.includes('text/html') || e.dataTransfer.types.includes('text/uri-list'));
        if (hasFiles || hasImageUrl) {
            isDraggingFiles = true;
            globalDragCounter++;
            dragOverlay.style.display = 'flex';
            setTimeout(() => { dragOverlay.style.opacity = '1'; }, 10);
        }
    });

    document.addEventListener('dragover', (e) => {
        if (isDraggingFiles) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        }
    });

    document.addEventListener('dragleave', (e) => {
        if (e.clientX === 0 && e.clientY === 0) {
            globalDragCounter = 0;
            isDraggingFiles = false;
            dragOverlay.style.opacity = '0';
            setTimeout(() => { dragOverlay.style.display = 'none'; }, 200);
        }
    });

    document.addEventListener('drop', (e) => {
        e.preventDefault();
        e.stopPropagation();
        globalDragCounter = 0;
        isDraggingFiles = false;
        dragOverlay.style.opacity = '0';
        setTimeout(() => { dragOverlay.style.display = 'none'; }, 200);

        let imageToSearch = null;

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file.type.startsWith('image/')) {
                imageToSearch = { type: 'file', data: file };
            }
        }
        else if (e.dataTransfer.getData('text/html')) {
            const html = e.dataTransfer.getData('text/html');
            const imgMatch = html.match(/src=["']([^"']+)["']/);
            if (imgMatch && imgMatch[1]) {
                const url = imgMatch[1];
                if (url.match(/\.(jpg|jpeg|png|gif|webp)$/i) || url.includes('shopify') || url.includes('imagekit')) {
                    imageToSearch = { type: 'url', data: url };
                }
            }
        }
        else if (e.dataTransfer.getData('text/uri-list')) {
            const url = e.dataTransfer.getData('text/uri-list');
            if (url.match(/\.(jpg|jpeg|png|gif|webp)$/i) || url.includes('shopify')) {
                imageToSearch = { type: 'url', data: url };
            }
        }

        if (imageToSearch) {
            openModal();
            setTimeout(() => {
                if (imageToSearch.type === 'file') handleFile(imageToSearch.data);
                else loadImageFromUrl(imageToSearch.data);
            }, 100);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isDraggingFiles) {
            globalDragCounter = 0;
            isDraggingFiles = false;
            dragOverlay.style.opacity = '0';
            setTimeout(() => { dragOverlay.style.display = 'none'; }, 200);
        }
        if ((e.key === 's' || e.key === 'S') && modal && !modal.classList.contains('hidden')) {
            if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
                e.preventDefault();
                triggerSearch();
            }
        }
    });

    dragOverlay.addEventListener('click', () => {
        globalDragCounter = 0;
        isDraggingFiles = false;
        dragOverlay.style.opacity = '0';
        setTimeout(() => { dragOverlay.style.display = 'none'; }, 200);
    });

    function openModal() {
        if (modal) {
            modal.classList.remove('hidden');
            document.body.classList.add('overflow-hidden')
            if (modalContent) modalContent.classList.add('vs-modal-empty');
        }
        if (uploadPrompt) uploadPrompt.classList.remove('hidden');
        loadPopularProducts();
    }

    function closeModal() {
        if (modal) modal.classList.add('hidden');
        if (modal) document.body.classList.remove('overflow-hidden');
        resetState();
    }

    if (openModalBtn) openModalBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.body.addEventListener('click', (e) => {
        const btn = e.target.closest('.visual-search-icon');
        if (btn) {
            e.preventDefault();
            const imageUrl = btn.getAttribute('data-image-url');
            openModal();
            if (imageUrl) loadImageFromUrl(imageUrl);
        }
    });

    if (uploadTrigger) uploadTrigger.addEventListener('click', (e) => { e.preventDefault(); fileInput.click(); });
    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('vs-upload-file-link')) { e.preventDefault(); fileInput.click(); }
    });

    if (fileInput) fileInput.addEventListener('change', (e) => { if (e.target.files?.[0]) handleFile(e.target.files[0]); });

    if (uploadArea) {
        uploadArea.addEventListener('dragover', (e) => { e.preventDefault(); e.stopPropagation(); uploadArea.classList.add('dragover'); });
        uploadArea.addEventListener('dragleave', () => { uploadArea.classList.remove('dragover'); });
        uploadArea.addEventListener('drop', (e) => {
            e.preventDefault();
            e.stopPropagation();
            uploadArea.classList.remove('dragover');
            if (e.dataTransfer.files?.[0]) handleFile(e.dataTransfer.files[0]);
        });
    }

    document.addEventListener('paste', (e) => {
        if (modal?.classList.contains('hidden')) return;
        for (let i = 0; i < e.clipboardData.items.length; i++) {
            if (e.clipboardData.items[i].type.indexOf('image') !== -1) {
                handleFile(e.clipboardData.items[i].getAsFile());
                break;
            }
        }
    });

    async function loadPopularProducts() {
        try {
            const handles = ['pink-tissue-moti-embroidered-saree-with-unstitched-blouse', 'kalki-deep-green-printed-kurta-set-in-tussar-silk-for-boys', 'black-indo-western-for-men-with-heavy-embroidery-on-suiting-fabric', 'navy-blue-printed-anarkali-set', 'kalki-white-printed-top-and-lehenga-set-in-cotton-silk-for-girls', 'maroon-bridal-moti-silk-lehenga-set-with-two-dupattas'];
            const query = `query { ${handles.map((h, i) => `p${i}: productByHandle(handle: "${h}") { id title handle featuredImage { url altText } }`).join(' ')} }`;
            const r = await fetch('https://uk.kalkifashion.com/api/2024-01/graphql.json', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': 'adce4ee916b13aa6db2d71a2662a8f91' },
                body: JSON.stringify({ query })
            });
            const data = await r.json();
            const products = [];
            Object.values(data.data).forEach((p) => {
                if (p?.title) products.push({ handle: p.handle, title: p.title, imageUrl: p.featuredImage?.url, imageAlt: p.featuredImage?.altText });
            });
            window.dataLayer.push({
                event: "image_search",
                "ecommerce": data.data
            });
            webengage.track('image_search', { data });
            popularProducts = products;
            renderPopularProducts();
        } catch (error) { }
    }

    function renderPopularProducts() {
        if (!popularProductsContainer) return;
        popularProductsContainer.innerHTML = '';
        popularProducts.forEach((p) => {
            const thumb = document.createElement('div');
            thumb.style.cssText = 'cursor: pointer;';
            const img = document.createElement('img');
            img.src = convertToImageKitUrl(p.imageUrl) || 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/placeholder_100x_fa232927-2a07-405b-9fbd-8cdcb957b893.png?v=1760600399';
            img.onerror = () => { img.src = 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/placeholder_100x_fa232927-2a07-405b-9fbd-8cdcb957b893.png?v=1760600399'; };
            thumb.appendChild(img);
            thumb.addEventListener('click', () => { loadImageFromUrl(p.imageUrl); });
            popularProductsContainer.appendChild(thumb);
        });
    }

    function handleFile(file) {
        if (!file.type.startsWith('image/')) { alert('Upload an image file.'); return; }
        if (modalContent) modalContent.classList.remove('vs-modal-empty');
        currentFile = file;
        hasInitialSearched = false;
        lastSearchCropData = null;
        resultsExpanded = false;

        // New image => forget the previous image's classification so it re-classifies once
        cachedGender = null;
        cachedCategory = null;
        cachedCropData = null;
        
        // Reset to collapsed
        if (resultsContainer) {
            resultsContainer.classList.remove('vs-results-expanded');
            resultsContainer.classList.add('vs-results-collapsed');
        }
        expandButton.innerHTML = '▼';
        
        const reader = new FileReader();
        reader.onload = (e) => { setupCropper(e.target.result); };
        reader.readAsDataURL(file);
    }

    async function loadImageFromUrl(url) {
        try {
            if (uploadPrompt) uploadPrompt.classList.add('hidden');
            if (loadingState) loadingState.classList.remove('hidden');
            const emptyState = resultsContainer?.querySelector('.vs-empty-state');
            if (emptyState) emptyState.classList.add('hidden');
            if (modalContent) modalContent.classList.remove('vs-modal-empty');
            let actualUrl = url.startsWith('//') ? 'https:' + url : url;
            const res = await fetch(actualUrl);
            const blob = await res.blob();
            const file = new File([blob], "product-image.jpg", { type: "image/jpeg" });
            if (loadingState) loadingState.classList.add('hidden');
            handleFile(file);
        } catch (error) {
            alert('Could not load image.');
            if (loadingState) loadingState.classList.add('hidden');
            if (uploadPrompt) uploadPrompt.classList.remove('hidden');
            if (cropperContainer) cropperContainer.classList.add('hidden');
            if (cropActions) cropActions.classList.add('hidden');
            const emptyState = resultsContainer?.querySelector('.vs-empty-state');
            if (emptyState) emptyState.classList.remove('hidden');
            if (modalContent) modalContent.classList.add('vs-modal-empty');
        }
    }

    function setupCropper(imageSrc) {
        if (uploadPrompt) uploadPrompt.classList.add('hidden');
        if (cropperContainer) cropperContainer.classList.remove('hidden');
        if (cropActions) cropActions.classList.remove('hidden');
        if (cropperImage) cropperImage.src = imageSrc;
        if (cropper) cropper.destroy();
        
        if (cropperImage) {
            cropper = new Cropper(cropperImage, {
                viewMode: 1, dragMode: 'crop', autoCropArea: 0.9, restore: false, guides: true,
                center: true, highlight: false, cropBoxMovable: true, cropBoxResizable: true, toggleDragModeOnDblclick: false,
            });

            setTimeout(() => {
                if (!hasInitialSearched && !isSearching) {
                    hasInitialSearched = true;
                    lastSearchCropData = JSON.stringify(cropper.getData());
                    triggerSearch();
                }
            }, CONFIG.INITIAL_SEARCH_DELAY);

            if (cropCheckInterval) clearInterval(cropCheckInterval);
            
            cropCheckInterval = setInterval(() => {
                if (!cropper || !hasInitialSearched || isSearching) return;
                
                try {
                    const currentData = JSON.stringify(cropper.getData());
                    
                    if (currentData !== lastSearchCropData) {
                        lastSearchCropData = currentData;
                        
                        if (autoSearchTimeout) clearTimeout(autoSearchTimeout);
                        
                        autoSearchTimeout = setTimeout(() => {
                            if (!isSearching) {
                                triggerSearch();
                            }
                        }, CONFIG.AUTO_SEARCH_DELAY);
                    }
                } catch (e) { }
            }, 300);
        }
    }


    // Returns true if the new crop differs enough from the cached one that the
    // garment/accessory in view likely changed (e.g. full outfit -> just the shoes).
    // Small refinements stay cached (fast); big jumps drop the cache (re-classify).
    function cropChangedSignificantly(prev, curr) {
        if (!prev || !curr) return true;
        const prevArea = (prev.width || 0) * (prev.height || 0);
        const currArea = (curr.width || 0) * (curr.height || 0);
        if (prevArea <= 0 || currArea <= 0) return true;
        const areaRatio = currArea / prevArea;
        // crop shrank to <55% or grew to >180% of the cached one => treat as a different subject
        if (areaRatio < 0.55 || areaRatio > 1.8) return true;
        // large positional shift relative to crop size => different region of the photo
        const dx = Math.abs((curr.x || 0) - (prev.x || 0));
        const dy = Math.abs((curr.y || 0) - (prev.y || 0));
        const ref = Math.sqrt(currArea);
        if ((dx + dy) > ref * 0.9) return true;
        return false;
    }

    function triggerSearch() {
        if (!cropper || isSearching) return;
        cropper.getCroppedCanvas({ maxWidth: 1024, maxHeight: 1024 }).toBlob((blob) => { performSearch(blob); }, 'image/jpeg', 0.9);
    }

    if (searchBtn) searchBtn.addEventListener('click', () => {
        if (autoSearchTimeout) clearTimeout(autoSearchTimeout);
        triggerSearch();
    });

    function resetState() {
        if (autoSearchTimeout) clearTimeout(autoSearchTimeout);
        if (cropCheckInterval) clearInterval(cropCheckInterval);
        if (cropper) { cropper.destroy(); cropper = null; }
        currentFile = null;
        isSearching = false;
        hasInitialSearched = false;
        lastSearchCropData = null;
        resultsExpanded = false;
        cachedGender = null;
        cachedCategory = null;
        cachedCropData = null;
        if (fileInput) fileInput.value = '';
        if (uploadPrompt) uploadPrompt.classList.remove('hidden');
        if (cropperContainer) cropperContainer.classList.add('hidden');
        if (cropActions) cropActions.classList.add('hidden');
        if (resultsContainer) {
            resultsContainer.classList.remove('vs-results-expanded');
            resultsContainer.classList.add('vs-results-collapsed');
            const productCards = resultsContainer.querySelectorAll('a');
            productCards.forEach(card => card.remove());
            const emptyState = resultsContainer.querySelector('.vs-empty-state');
            if (emptyState) {
                emptyState.classList.remove('hidden');
                emptyState.textContent = 'Upload an image to see results here.';
                emptyState.style.color = '#666';
            }
        }
        expandButton.innerHTML = '▼';
        if (loadingState) loadingState.classList.add('hidden');
        if (modalContent) modalContent.classList.add('vs-modal-empty');
    }

    async function performSearch(imageBlob, retryCount = 0) {
        if (isSearching) return;
        isSearching = true;
        const emptyState = resultsContainer?.querySelector('.vs-empty-state');
        if (emptyState) emptyState.classList.add('hidden');
        
        const productCards = resultsContainer?.querySelectorAll('a');
        if (productCards) productCards.forEach(card => card.style.display = 'none');
        
        if (loadingState) loadingState.classList.remove('hidden');
        try {
            const base64Image = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(imageBlob);
            });

            // Crop-aware cache: only reuse the cached classification if the crop is
            // basically the same. A big crop change (outfit -> accessory) invalidates it
            // so the server re-classifies the new region instead of pinning the old garment.
            let currentCrop = null;
            try { currentCrop = cropper ? cropper.getData() : null; } catch (e) { currentCrop = null; }
            if (cropChangedSignificantly(cachedCropData, currentCrop)) {
                cachedGender = null;
                cachedCategory = null;
            }

            const body = { imageBase64: base64Image };
            if (cachedGender && cachedCategory !== null) {
                body.gender = cachedGender;
                body.category = cachedCategory;
            }

            const response = await fetch('https://api.kalkifashion.com/image-search/imageSearch.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
            if (!response.ok) throw new Error(`Server returned ${response.status}`);
            const data = await response.json();

            // Cache classification + the crop it was computed from, so only similar
            // crops reuse it (accessory crops will differ enough to re-classify).
            if (data.queryGender && data.queryGender !== 'unknown') {
                cachedGender = data.queryGender;
                cachedCategory = data.queryCategory || '';
                cachedCropData = currentCrop;
            }

            // Honest no-match from backend (low similarity) OR genuinely empty
            if (data.noMatch || !data.products || data.products.length === 0) {
                const stale = resultsContainer?.querySelectorAll('a');
                if (stale) stale.forEach(card => card.remove());
                if (emptyState) {
                    emptyState.style.color = '#666';
                    emptyState.textContent = data.message || 'No similar products found. Try a clearer photo, or crop to just the garment.';
                    emptyState.classList.remove('hidden');
                }
            } else {
                renderResults(data.products);
            }
        } catch (error) {
            if (retryCount < CONFIG.MAX_RETRIES) {
                setTimeout(() => { performSearch(imageBlob, retryCount + 1); }, CONFIG.RETRY_DELAY);
            } else {
                if (emptyState) {
                    emptyState.style.color = 'red';
                    emptyState.textContent = 'Error. Try again.';
                    emptyState.classList.remove('hidden');
                }
            }
        } finally {
            if (loadingState) loadingState.classList.add('hidden');
            isSearching = false;
        }
    }

    function renderResults(products) {
        if (resultsContainer) {
            const emptyState = resultsContainer.querySelector('.vs-empty-state');
            if (emptyState) emptyState.classList.add('hidden');
            
            const productCards = resultsContainer.querySelectorAll('a');
            productCards.forEach(card => card.remove());
            
            const inStockProducts = products
                .filter(p => p.inStock !== false)
                .filter(p => !blockedIdSet.has(normalizeProductId(p.id)));  // hide blocked products
            
            if (inStockProducts.length === 0) {
                if (emptyState) {
                    emptyState.textContent = 'No available products found.';
                    emptyState.classList.remove('hidden');
                }
                return;
            }
            
            resultsContainer.style.cssText = 'display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 15px; align-content: start;';
            inStockProducts.forEach((p) => {
                const card = document.createElement('a');
                card.href = p.uri || p.url || '#';
                card.target = '_blank';
                card.style.cssText = 'text-decoration: none; color: #111; display: flex; flex-direction: column; background: #fff; border-radius: 8px; border: 1px solid #ddd; overflow: hidden; min-height: 300px; transition: box-shadow 0.2s;';
                card.onmouseenter = () => { card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; };
                card.onmouseleave = () => { card.style.boxShadow = 'none'; };

                const imgContainer = document.createElement('div');
                imgContainer.style.cssText = 'height: 258px; width: 100%; background: #f4f4f4; flex-shrink: 0; position: relative; overflow: hidden;';
                const img = document.createElement('img');
                img.src = convertToImageKitUrl(p.imageUri || p.image_url) || 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/placeholder_100x_fa232927-2a07-405b-9fbd-8cdcb957b893.png?v=1760600399';
                img.onerror = () => { img.src = 'https://cdn.shopify.com/s/files/1/0636/0134/4666/files/placeholder_100x_fa232927-2a07-405b-9fbd-8cdcb957b893.png?v=1760600399'; };
                img.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; display: block;';
                imgContainer.appendChild(img);
                card.appendChild(imgContainer);

                const infoContainer = document.createElement('div');
                infoContainer.style.cssText = 'padding: 12px; display: flex; flex-direction: column; flex-grow: 1; text-align: left;';
                const titleEl = document.createElement('h3');
                titleEl.textContent = p.title || 'Product';
                titleEl.style.cssText = 'font-size: 13px; font-weight: 500; margin: 0 0 8px 0; color: #111; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; font-family: sans-serif;';
                infoContainer.appendChild(titleEl);

                const pricesContainer = document.createElement('div');
                pricesContainer.style.cssText = 'margin-top: auto; display: none; align-items: center; gap: 6px; flex-wrap: wrap;';
                
                const price = parseInt(Math.round(parseFloat(p.priceInfo?.price || p.price || 0)), 10);
                const compareAtPrice = parseInt(Math.round(parseFloat(p.priceInfo?.compareAtPrice || p.originalPrice || 0)), 10);
                const hasDiscount = compareAtPrice && compareAtPrice !== 0 && compareAtPrice !== price;
                
                const priceEl = document.createElement('span');
                priceEl.textContent = `₹${price}`;
                
                if (hasDiscount) {
                    priceEl.style.cssText = 'font-weight: 700; font-size: 14px; color: #d32f2f;';
                } else {
                    priceEl.style.cssText = 'font-weight: 700; font-size: 14px; color: #111;';
                }
                
                pricesContainer.appendChild(priceEl);
                
                if (hasDiscount) {
                    const comparePriceEl = document.createElement('span');
                    comparePriceEl.textContent = `₹${compareAtPrice}`;
                    comparePriceEl.style.cssText = 'font-size: 12px; color: #999; text-decoration: line-through;';
                    pricesContainer.appendChild(comparePriceEl);
                }
                
                infoContainer.appendChild(pricesContainer);
                
                if (hasDiscount) {
                    const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
                    const badge = document.createElement('div');
                    badge.textContent = `ON SALE`;
                    badge.style.cssText = 'position: absolute; top: 4px; left: 4px; background: #d32f2f; color: white; padding: 2px 4px; border-radius: 3px; font-size: 9px; font-weight: 500; z-index: 10;';
                    imgContainer.style.position = 'relative';
                    imgContainer.appendChild(badge);
                }

                card.appendChild(infoContainer);
                card.style.display = 'flex';
                resultsContainer.appendChild(card);
            });
        }
    }
});